import { useState } from "react";
import './Faq.css';

const faqData = [
  {
    section: "Orders & Products",
    items: [
      { q: "How do I place an order on Garshya?", a: "Browse, select your product, add it to cart, and proceed to checkout. Follow the steps to complete payment or confirm your order." },
      { q: "Are all products on Garshya verified?", a: "Yes. Every product and service goes through a strict quality check before being listed. If it’s on Garshya, it meets our standards." },
      { q: "Why are there limited options compared to other platforms?", a: "Because we believe in curated choices, not endless listings. We focus on quality over quantity." },
    ]
  },
  {
    section: "Payments",
    items: [
      { q: "What payment methods do you accept?", a: "We accept UPI, credit/debit cards, net banking, wallets, and Cash on Delivery (COD with conditions)." },
      { q: "Is Cash on Delivery (COD) available?", a: "Yes, with a premium approach:\n• Available for orders up to ₹3,000 \n• Requires 10% advance payment \n• Remaining amount payable at delivery" },
      { q: "Is it safe to make online payments on Garshya?", a: "Absolutely. All transactions are processed through secure and encrypted payment gateways with additional authentication layers." },
    ]
  },
  {
    section: "Shipping & Delivery",
    items: [
      { q: "How long does delivery take?", a: "• Metro cities: 2–4 business days\n• Other locations: 3–6 business days\nDelivery timelines may vary based on location and product availability." },
      { q: "Do you deliver across India?", a: "Yes, we deliver to most serviceable pincodes across India." },
      { q: "How can I track my order?", a: "Once your order is shipped, you will receive tracking details via email/SMS." },
    ]
  },
  {
    section: "Returns, Cancellations & Refunds",
    items: [
      { q: "Can I cancel my order?", a: "Yes, orders can be cancelled before they are shipped. Once shipped, cancellation may not be possible." },
      { q: "What is your return policy?", a: "Returns are accepted for eligible products based on specific conditions (to be detailed in our Return Policy page)." },
      { q: "When will I receive my refund?", a: "Refunds are processed after product verification and typically reflect within 5–7 business days, depending on your payment method." },
    ]
  },
  {
    section: "Account & Support",
    items: [
      { q: "Do I need an account to place an order?", a: "No, you can place an order as a guest. However, creating an account helps you track orders easily." },
      { q: "How can I contact Garshya support?", a: "You can reach us via email or through the Contact Us page. Our team typically responds within 24–48 business hours." },
    ]
  },
  {
    section: "Trust & Quality",
    items: [
      { q: "How does Garshya ensure quality?", a: "We carefully select products, verify sellers, and maintain strict quality benchmarks before listing anything on our platform." },
      { q: "Why should I trust Garshya?", a: "Because we don’t aim to sell everything — we aim to offer only what’s worth your trust." },
    ]
  }
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page row">
      <div className="faq-wrap card col-xl-12">
        <h1 className="faq-title">FAQ</h1>
        <p className="faq-subtitle">Clear answers. No confusion. Just how it should be.</p>
        {faqData.map((section, secIdx) => (
          <div key={secIdx} className="faq-section">
            <h2 className="faq-section-title">{section.section}</h2>
            {section.items.map((item, idx) => {
              const index = `${secIdx}-${idx}`;
              const isOpen = openIndex === index;
              return (
                <div key={index} className={`faq-card ${isOpen ? "open" : ""}`}>
                  <div className="faq-question" onClick={() => toggleAnswer(index)}>
                    {item.q}
                    <span className="faq-toggle">{isOpen ? '-' : '+'}</span>
                  </div>
                  {isOpen && <div className="faq-answer">{item.a}</div>}
                </div>
              );
            })}
          </div>
        ))}
        <p className="faq-footer">Still have questions? We’re here to help. Garshya support is just a message away.</p>
      </div>
    </div>
  );
}